import { useContext } from 'react'

import { CommercialBudgetContext } from '@provider/Budget/CommercialProvider'

import type { IBudgetCommercialContext } from '@base/@types/providers/Budget/Commercial'

export default function useCommercialBudget(): IBudgetCommercialContext {
  const context = useContext(CommercialBudgetContext)

  return context
}
